import logger from "@utils/logger";
import parsePhoneNumber from "libphonenumber-js/max";

const gtm = (event, user = null) => {
  logger.debug("gtm", event, user);
  const gtmEvent = event;
  window.dataLayer = window.dataLayer || [];

  if (user !== null) {
    const phoneNumber = parsePhoneNumber(
      user.billing_address?.phone || "",
      user.billing_address?.phone_country || "",
    )?.number?.replace("+", "");

    gtmEvent.user_data = {};
    gtmEvent.user_data.email_address = user.email && user.email;
    gtmEvent.user_data.address = {
      first_name: user.first_name && user.first_name,
      last_name: user.last_name && user.last_name,
      city: user.billing_address?.city && user.billing_address?.city,
      country: user.billing_address?.country && user.billing_address?.country,
      zip: user.billing_address?.zip && user.billing_address?.zip,
      phone_number: phoneNumber && phoneNumber,
    };
  }

  window.dataLayer.push(gtmEvent);
};

export default gtm;
